import { Chip, styled } from '@mui/material';

export const ChipStyled = styled(Chip)`
  background: ${({ theme }) => theme.palette.chip.secondary};

  ${({ theme }) => theme.breakpoints.up('mobile')} {
    background: ${({ theme }) => theme.palette.chip.main};
  }
`;
